module.exports = "<div class=\"row\">\n    <div class=\"col-xl-12\">\n        <h2 class=\"page-header text-center\">\n           <span> {{heading}} </span>\n        </h2>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/page-header/page-header.component.html
// module id = ./src/app/shared/modules/page-header/page-header.component.html
// module chunks = main